<template>
    <div class="navigation">
        <div class="nav-box">
            <div
                class="nav-item"
                v-for="(item, index) in navList"
                :key="item.value"
                :class="[
                    active === item.value ? 'active-nav-item' : '',
                    item.children && item.children.length ? 'has-children' : '',
                    openIndex === index ? 'open-nav-item' : ''
                ]"
                @mouseenter="openItem(index)"
                @mouseleave="closeItem(index)"
                @click="navChange(item, false, true)"
            >
                <div class="nav-text">{{ item.name }}</div>

                <!-- 悬浮弹出的子菜单 -->
                <transition name="nav-pop">
                    <div
                        v-if="item.children && item.children.length && openIndex === index"
                        class="nav-children"
                        :class="{ 'nav-children--wide': item.children.length > 2 }"
                    >
                        <div
                            class="nav-child"
                            v-for="child in item.children"
                            :key="child.value"
                            :class="[
                                subActive === child.value ? 'active-nav-child' : '',
                                child.children && child.children.length ? 'has-children' : ''
                            ]"
                            @click.stop="navChange(child, false, false)"
                        >
                            <span class="nav-child-dot"></span>
                            <span class="nav-child-text">{{ child.name }}</span>
                            <i v-if="child.children && child.children.length" class="nav-child-arrow"></i>

                            <!-- 二级子菜单 -->
                            <transition name="nav-fly">
                                <div
                                    v-if="child.children && child.children.length && hoverChild === child.value"
                                    class="nav-grandchildren"
                                    @mouseenter="hoverChildOpen(child)"
                                    @mouseleave="hoverChildClose"
                                >
                                    <div
                                        class="nav-grandchild"
                                        v-for="grand in child.children"
                                        :key="grand.value"
                                        :class="{ 'active-nav-child': subActive === grand.value }"
                                        @click.stop="navChange(grand, false, false)"
                                    >
                                        <span class="nav-child-dot"></span>
                                        <span class="nav-child-text">{{ grand.name }}</span>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
// 合并后的导航结构：一级为业务板块，hover 弹出子项
export default {
  name: "navigation",
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: "entitylink",
      subActive: "",
      // 上一次高亮子项所属的父级，用于判断是否需要重置三级展开状态
      lastMatchedParent: "",
      // 当前展开的一级导航下标
      openIndex: -1,
      // 当前展开的二级导航 value
      hoverChild: "",
      // 悬浮关闭延时器（避免鼠标穿越间隙时菜单闪烁）
      closeTimer: null,
      childCloseTimer: null,
      navList: [
        {
          name: "实体关联域名资产查询",
          value: "entitylink",
          path: "/entitylink"
        },
        {
          name: "权威侧安全监控",
          value: "auth",
          path: "",
          children: [
            {
              name: "域名配置安全监控",
              value: "authrisk",
              path: "/authrisk"
            },
            {
              name: "域名授权依赖风险监控",
              value: "authdep",
              path: "/authdep"
            }
          ]
        },
        {
          name: "递归侧安全监控",
          value: "rec",
          path: "",
          children: [
            {
              name: "DNS解析器全球态势监控",
              value: "resolverevolution",
              path: "/resolverevolution",
              children: [
                {
                  name: "基本态势",
                  value: "resolverevolution-basic",
                  path: "/resolverevolution",
                  query: { tab: "basic" }
                },
                {
                  name: "风险态势",
                  value: "resolverevolution-risk",
                  path: "/resolverevolution",
                  query: { tab: "risk" }
                }
              ]
            },
            {
              name: "教育网递归监控",
              value: "recrisk",
              path: "/recrisk"
            }
          ]
        },
        {
          name: "恶意域名和域名滥用检测",
          value: "maliciousdomain",
          path: "/maliciousdomain"
        }
      ]
    };
  },
  created() {
    this.syncActiveByRoute();
  },
  watch: {
    // 路由变化（含 tab 变化）时同步高亮
    $route() {
      this.syncActiveByRoute();
    }
  },
  beforeDestroy() {
    this.clearTimers();
  },
  methods: {
    clearTimers() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
      if (this.childCloseTimer) {
        clearTimeout(this.childCloseTimer);
        this.childCloseTimer = null;
      }
    },

    // 根据当前路由计算一级 / 二级高亮项
    syncActiveByRoute() {
      const path = this.$route.path || "";
      const tab = (this.$route.query && this.$route.query.tab) || "";

      let matchedTop = "";

      let matchedSub = "";

      let matchedParent = "";

      if (path.includes("resolverevolution")) {
        matchedTop = "rec";
        matchedParent = "resolverevolution";
        // 机构解析链风险查询已收进基本态势顶部检索入口，tab=org 时高亮回落到基本态势
        matchedSub = tab === "risk" ? "resolverevolution-risk" : "resolverevolution-basic";
      } else if (path.includes("recrisk")) {
        matchedTop = "rec";
        matchedSub = "recrisk";
      } else if (path.includes("authrisk")) {
        matchedTop = "auth";
        matchedSub = "authrisk";
      } else if (path.includes("authdep")) {
        matchedTop = "auth";
        matchedSub = "authdep";
      } else if (path.includes("maliciousdomain")) {
        matchedTop = "maliciousdomain";
        matchedSub = "maliciousdomain";
      } else if (path.includes("entitylink")) {
        matchedTop = "entitylink";
        matchedSub = "entitylink";
      }

      if (matchedTop) {
        this.active = matchedTop;
        this.subActive = matchedSub;
      }

      // 只在“高亮子项发生了变化”时联动三级展开状态，避免悬浮点击时收起/闪烁
      if (matchedParent !== this.lastMatchedParent) {
        this.lastMatchedParent = matchedParent;
        this.hoverChild = matchedParent;
      }

      // 高亮到子项时，保持对应父级展开
      if (this.openIndex === -1) {
        const index = this.navList.findIndex(item => item.value === this.active);

        if (index > -1 && this.navList[index].children && this.navList[index].children.length) {
          this.openIndex = index;
        }
      }
    },

    openItem(index) {
      if (this.disabled) {
        return;
      }
      this.clearTimers();
      this.openIndex = index;

      const item = this.navList[index];

      if (!item || !item.children) {
        this.hoverChild = "";
        return;
      }
      // 悬浮一级导航时就把其下的三级菜单一并展开，无需再点击二级项
      if (!this.hoverChild || !this.hasHoverChild(item, this.hoverChild)) {
        const firstNested = item.children.find(child => child.children && child.children.length);

        this.hoverChild = firstNested ? firstNested.value : "";
      }
    },

    // 判断某个三级菜单的父项是否仍属于当前一级导航下
    hasHoverChild(topItem, value) {
      return topItem.children.some(child => child.value === value
        && child.children && child.children.length);
    },

    closeItem(index) {
      if (this.openIndex !== index) {
        return;
      }
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
      }
      this.closeTimer = setTimeout(() => {
        this.openIndex = -1;
        this.hoverChild = "";
      }, 180);
    },

    hoverChildOpen(child) {
      if (this.childCloseTimer) {
        clearTimeout(this.childCloseTimer);
        this.childCloseTimer = null;
      }
      this.hoverChild = child.value;
    },

    hoverChildClose() {
      if (this.childCloseTimer) {
        clearTimeout(this.childCloseTimer);
      }
      this.childCloseTimer = setTimeout(() => {
        this.hoverChild = "";
      }, 180);
    },

    navChange(item, isChange, isTopLevel) {
      if (this.disabled) {
        return;
      }

      // 一级且带子菜单（纯分组）：点击只展开，不做路由跳转
      if (isTopLevel && item.children && item.children.length && !item.path) {
        this.openIndex = this.navList.findIndex(nav => nav.value === item.value);
        return;
      }

      // 三级子项（如“基本态势/风险态势”）复用同一路由，用 query 区分
      if (item.query) {
        const samePath = this.$route.path === item.path;
        const sameQuery = String((this.$route.query && this.$route.query.tab) || "") === String(item.query.tab);

        if (!samePath || !sameQuery) {
          this.$router.push({ path: item.path, query: item.query });
        }
      } else if (item.path && this.$route.path !== item.path) {
        this.$router.push(item.path);
      }

      this.$emit("navChange", item.value, isChange);
    }
  }
};
</script>

<style scoped lang="less">
.navigation {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    width: 90%;
    max-width: 1719px;
    height: 68px;
    z-index: 20;
    background-image: url("../assets/nav/nav-bg.png");
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;

    .nav-box {
        width: clamp(800px, 65%, 1120px);
        height: 122px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 26px;
        display: flex;
        justify-content: space-between;

        .nav-item {
            user-select: none;
            cursor: pointer;
            width: clamp(100px, 10vw, 120px);
            height: clamp(90px, 9vw, 104px);
            background-image: url("../assets/nav/nav-item-bg.png");
            background-size: 100%;
            background-repeat: no-repeat;
            margin-top: 13px;
            box-sizing: border-box;
            padding: 0 6px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: transform 0.25s ease;

            &:hover {
                background-image: url("../assets/nav/active-item-bg.png");
                transform: translateY(-4px);
            }

            .nav-text {
                font-size: clamp(12px, 1.1vw, 15px);
                color: #C1D5FF;
                font-weight: 800;
                font-family: AlibabaRegular;
                text-align: center;
                line-height: 1.25;
                padding: 0 4px;
                text-shadow: 0 0 8px rgba(24, 144, 255, 0.5);
                transition: color 0.25s ease;
            }

            &:hover .nav-text,
            &.active-nav-item .nav-text {
                color: #fff;
            }
        }

        .active-nav-item {
            background-image: url("../assets/nav/active-item-bg.png");
        }

        // ===== 悬浮弹出的子菜单 =====
        .nav-children {
            position: absolute;
            left: 50%;
            bottom: calc(100% - 6px);
            transform: translateX(-50%);
            min-width: 210px;
            padding: 10px 6px;
            box-sizing: border-box;
            background: rgba(6, 26, 58, 0.94);
            border: 1px solid rgba(64, 158, 255, 0.45);
            border-radius: 6px;
            box-shadow: 0 0 18px rgba(24, 144, 255, 0.45), inset 0 0 22px rgba(24, 144, 255, 0.12);
            backdrop-filter: blur(4px);
            z-index: 30;

            // 顶部连接线装饰
            &::after {
                content: "";
                position: absolute;
                left: 50%;
                bottom: -9px;
                transform: translateX(-50%);
                width: 0;
                height: 0;
                border-left: 7px solid transparent;
                border-right: 7px solid transparent;
                border-top: 9px solid rgba(64, 158, 255, 0.55);
            }
        }

        .nav-child {
            position: relative;
            display: flex;
            align-items: center;
            height: 38px;
            padding: 0 14px 0 12px;
            border-radius: 4px;
            cursor: pointer;
            white-space: nowrap;
            transition: background 0.22s ease, transform 0.22s ease;

            .nav-child-dot {
                width: 6px;
                height: 6px;
                margin-right: 8px;
                flex-shrink: 0;
                border-radius: 50%;
                background: rgba(193, 213, 255, 0.55);
                box-shadow: 0 0 6px rgba(24, 144, 255, 0.6);
                transition: background 0.22s ease, box-shadow 0.22s ease;
            }

            .nav-child-text {
                font-size: 14px;
                font-weight: 700;
                color: #C1D5FF;
                font-family: AlibabaRegular;
                transition: color 0.22s ease;
            }

            .nav-child-arrow {
                margin-left: 10px;
                width: 0;
                height: 0;
                border-top: 4px solid transparent;
                border-bottom: 4px solid transparent;
                border-left: 6px solid rgba(193, 213, 255, 0.7);
                transition: border-left-color 0.22s ease;
            }

            &:hover {
                background: linear-gradient(90deg, rgba(24, 144, 255, 0.35), rgba(24, 144, 255, 0.08));
                transform: translateX(3px);

                .nav-child-text {
                    color: #fff;
                }

                .nav-child-dot {
                    background: #409eff;
                    box-shadow: 0 0 10px #409eff;
                }

                .nav-child-arrow {
                    border-left-color: #409eff;
                }
            }

            &.active-nav-child {
                background: linear-gradient(90deg, rgba(24, 144, 255, 0.4), rgba(24, 144, 255, 0.1));

                .nav-child-text {
                    color: #fff;
                }

                .nav-child-dot {
                    background: #409eff;
                    box-shadow: 0 0 10px #409eff;
                }
            }
        }

        // ===== 二级子菜单 =====
        .nav-grandchildren {
            position: absolute;
            left: 0;
            bottom: calc(100% + 4px);
            min-width: 100%;
            padding: 10px 6px;
            box-sizing: border-box;
            background: rgba(6, 26, 58, 0.96);
            border: 1px solid rgba(64, 158, 255, 0.45);
            border-radius: 6px;
            box-shadow: 0 0 18px rgba(24, 144, 255, 0.45), inset 0 0 22px rgba(24, 144, 255, 0.12);
            backdrop-filter: blur(4px);
            z-index: 31;

            &::after {
                content: "";
                position: absolute;
                left: 22px;
                bottom: -8px;
                width: 0;
                height: 0;
                border-left: 6px solid transparent;
                border-right: 6px solid transparent;
                border-top: 8px solid rgba(64, 158, 255, 0.55);
            }
        }

        .nav-grandchild {
            display: flex;
            align-items: center;
            height: 34px;
            padding: 0 14px 0 12px;
            border-radius: 4px;
            cursor: pointer;
            white-space: nowrap;
            transition: background 0.22s ease, transform 0.22s ease;

            .nav-child-dot {
                width: 6px;
                height: 6px;
                margin-right: 8px;
                flex-shrink: 0;
                border-radius: 50%;
                background: rgba(193, 213, 255, 0.55);
                box-shadow: 0 0 6px rgba(24, 144, 255, 0.6);
            }

            .nav-child-text {
                font-size: 13px;
                font-weight: 700;
                color: #C1D5FF;
                font-family: AlibabaRegular;
            }

            &:hover,
            &.active-nav-child {
                background: linear-gradient(90deg, rgba(24, 144, 255, 0.4), rgba(24, 144, 255, 0.1));
                transform: translateX(3px);

                .nav-child-text {
                    color: #fff;
                }

                .nav-child-dot {
                    background: #409eff;
                    box-shadow: 0 0 10px #409eff;
                }
            }
        }
    }

    // ===== 弹出动画 =====
    .nav-pop-enter-active {
        animation: navPopIn 0.24s cubic-bezier(0.22, 1, 0.36, 1);
    }

    .nav-pop-leave-active {
        animation: navPopOut 0.16s ease-in forwards;
    }

    .nav-fly-enter-active {
        animation: navFlyIn 0.22s cubic-bezier(0.22, 1, 0.36, 1);
    }

    .nav-fly-leave-active {
        animation: navFlyOut 0.14s ease-in forwards;
    }

    @keyframes navPopIn {
        0% {
            opacity: 0;
            transform: translateX(-50%) translateY(14px) scale(0.94);
        }
        60% {
            opacity: 1;
            transform: translateX(-50%) translateY(-3px) scale(1.01);
        }
        100% {
            opacity: 1;
            transform: translateX(-50%) translateY(0) scale(1);
        }
    }

    @keyframes navPopOut {
        0% {
            opacity: 1;
            transform: translateX(-50%) translateY(0) scale(1);
        }
        100% {
            opacity: 0;
            transform: translateX(-50%) translateY(10px) scale(0.96);
        }
    }

    @keyframes navFlyIn {
        0% {
            opacity: 0;
            transform: translateY(10px) scale(0.96);
        }
        100% {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }

    @keyframes navFlyOut {
        0% {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
        100% {
            opacity: 0;
            transform: translateY(8px) scale(0.97);
        }
    }

    // 移动端适配
    @media (max-width: 768px) {
        width: 100%;
        height: 60px;

        .nav-box {
            width: 96%;
            bottom: 15px;

            .nav-item {
                width: auto;
                flex: 1;
                height: 75px;
                padding: 0 3px;

                .nav-text {
                    font-size: 11px;
                    padding: 0 2px;
                }
            }

            .nav-children {
                min-width: 168px;

                .nav-child {
                    height: 34px;

                    .nav-child-text {
                        font-size: 12px;
                    }
                }
            }

            .nav-grandchildren {
                min-width: 120px;

                .nav-grandchild .nav-child-text {
                    font-size: 12px;
                }
            }
        }
    }
}
</style>
